import { Component, Input, OnInit } from '@angular/core';
import checkListData from './checklist_stub.json';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { AppConfig } from '../../../../../../../app.config';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-rental-reservation-checklist',
  templateUrl: './rental-reservation-checklist.component.html',
  styleUrls: ['./rental-reservation-checklist.component.scss'],
})
export class RentalReservationChecklistComponent implements OnInit {
  @Input() reservation;

  public attachments: any = [];
  public qrCodeURL: string = null;
  public allowReloadLoop: boolean = true;

  constructor(
    public rentalsService: RentalsService,
    private appConfig: AppConfig,
    public translate: TranslateService,
    public confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.qrCodeURL =
      'https://rentals.hubtiger.com/rentals/reservation-attachments/' +
      this.reservation.webIdentifier +
      (this.appConfig.isDev() ? '?dev=true' : '');

    this.setupRentalsChecklists();
    this.getAttachments();
    this.reloadAttachments();
  }

  ngOnDestroy(): void {
    this.allowReloadLoop = false;
  }

  reloadAttachments() {
    setTimeout(() => {
      if (this.allowReloadLoop) {
        this.getAttachments();
        this.reloadAttachments();
      }
    }, 20000);
  }

  setupRentalsChecklists() {
    this.reservation.reservedProducts.forEach((product) => {
      product.checklist = JSON.parse(JSON.stringify(checkListData));
    });
  }

  getAttachments() {
    this.rentalsService
      .getRentalReservationAttachments(
        this.reservation.defaultPartnerID,
        this.reservation.id,
      )
      .subscribe((attachments) => {
        this.attachments = attachments;
      });
  }

  showProductAttachments(product) {
    return this.attachments.filter((x) => {
      return x.productID === product.productID;
    });
  }

  getfilteredLeavingChecklist(checklist) {
    return checklist.filter((x) => {
      return x.isLeavingCheck;
    });
  }

  getfilteredReturningChecklist(checklist) {
    return checklist.filter((x) => {
      return x.isReturningCheck;
    });
  }

  deleteAttachment(attachment) {
    this.confirmationService.confirm({
      message: this.translate.instant(
        'bikeshop.modal.update_job_card.attachments.delete_attachment',
      ),
      accept: () => {
        var index = this.attachments
          .map((x) => {
            return x.id;
          })
          .indexOf(attachment.id);
        this.attachments.splice(index, 1);
        this.rentalsService
          .deleteRentalReservationAttachment(
            this.reservation.defaultPartnerID,
            this.reservation.id,
            attachment.id,
          )
          .subscribe(
            (attachments) => {
              //this.attachments = attachments;
            },
            (err) => {
              this.getAttachments();
            },
          );
      },
    });
  }

  openAttachment(attachment: any) {
    window.open(attachment.attachmentURL, '_blank');
  }

  async addAttachment(event, product) {
    if (event.target.files && event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        var data: any = await this.readFileAsync(file);

        this.attachments.push({
          productID: product.productID,
          attachmentURL: data,
          attachmentType: file.type,
          attachmentName: file.name,
        });

        var attachmentData = {
          PartnerID: this.reservation.defaultPartnerID,
          ReservationID: this.reservation.id,
          ProductID: product.productID,
          MediaData: data.replace(/^data:(.*;base64,)?/, ''),
          MediaType: file.type,
          FileName: file.name,
        };

        this.rentalsService
          .postRentalReservationAttachment(attachmentData)
          .subscribe(
            (attachments) => {
              this.attachments = attachments;
            },
            (err) => {
              this.getAttachments();
            },
          );
      }
    }
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = reject;
    });
  }
}
